import request from '../../config/axiosConfig';
import {
  GET_LIST_USER_EVENTS, CREATE_USER_EVENT, UPDATE_USER_EVENT, DELETE_USER_EVENT
} from '../../constants/apiEndPoint';

const userEventService = {
  getList: async (dataBody) => {
    const { data } = await request({ url: GET_LIST_USER_EVENTS, method: 'POST', data: dataBody });
    return data;
  },
  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_USER_EVENT, method: 'POST', data: dataBody });
    return data;
  },
  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_USER_EVENT, method: 'POST', data: { id, ...dataBody } });
    return data;
  },
  delete: async (id) => {
    const { data } = await request({ url: DELETE_USER_EVENT, method: 'POST', data: { id } });
    return data;
  },
};

export default userEventService;
